import * as actionTypes from "../../constants/actionTypes";
import * as resultCodes from "../../constants/resultCodes";
import * as methods from "../../constants/methods";
import * as handlers from "../../constants/handlers";
import * as rccHelper from "../../helpers/rccResponseHelper";
import * as messageHelper from "../../helpers/messageHelper";
import * as modelHelper from "../../helpers/modelHelper";

export const processWebsocketResponse = (method, response, state) => {
    switch (method) {
        case handlers.INIT_MACHINE_INFO:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_INFO,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_DEVICES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_DEVICES,
                    payload: {
                        devices: rccHelper.processDeviceList(response.data)
                    }
                }
            ];
        case handlers.INIT_MACHINE_CANISTERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_CANISTERS,
                    payload: {
                        canisterList: modelHelper.mapCanistersToObjects(response.data, state.global.allColorantList, [])
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_GET_DIALOG
                    },
                    method: handlers.MACHINE_GET_DIALOG,
                    tabId: 0,
                    safe: true
                }
            ];
        case handlers.INIT_MACHINE_CHANNELS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_CHANNELS,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_ERRORS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            if (response.data === undefined) {
                return [];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_ERRORS,
                    payload: {
                        errors: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_SENSORS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.UPDATE_MACHINE_SENSOR,
                    payload: {
                        update: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_HISTORY:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_HISTORY_ACTIONS,
                    payload: {
                        historyActions: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_AUTOTASK_TYPES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_AUTOTASK_TYPES,
                    payload: {
                        data: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_AUTOTASKS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_AUTOTASK_LIST,
                    payload: {
                        autotaskList: response.data
                    }
                },
                {
                    type: actionTypes.RCC_REQUEST,
                    payload: {
                        type: methods.METHOD_MACHINE_START_AUTOTASK
                    },
                    method: handlers.MACHINE_START_AUTOTASK,
                    tabId: 0,
                    safe: true
                }
            ];
        case handlers.INIT_MACHINE_PURGE_RULES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_SMART_PURGE_RULES_LIST,
                    payload: {
                        smartPurgeRulesList: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_CAN_BATCH_NUMBERS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_ALL_BATCH_NUMBERS,
                    payload: {
                        batchNumbers: response.data
                    }
                }
            ];
        case handlers.INIT_PRINTER_PRINTERS_LIST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_PRINTERS_LIST,
                    payload: {
                        printerList: response.data
                    }
                }
            ];
        case handlers.INIT_PRINTER_TEMPLATES_LIST:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_TEMPLATES_LIST,
                    payload: {
                        templateList: response.data
                    }
                }
            ];
        case handlers.INIT_DRIVER_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_DRIVER_CONFIGURATION,
                    payload: {
                        configuration: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_CONFIGURATION,
                    payload: {
                        machineConfigurationList: response.data
                    }
                },
                {type: actionTypes.SYNC_MACHINE_CONFIGURATION}
            ];
        case handlers.INIT_RCC_COLORANTS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case handlers.INIT_MACHINE_UNITS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_UNITS,
                    payload: {
                        unitList: response.data
                    }
                }
            ];
        case handlers.INIT_MACHINE_MESSAGES:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_MACHINE_MESSAGE_CODES,
                    payload: {
                        messageCodeList: rccHelper.mapMachineMessageCodes(response)
                    }
                }
            ];
        case handlers.INIT_SPECTRO_CONFIGURATION:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.INIT_SPECTRO_CONFIGURATION,
                    payload: {
                        configuration: response.data
                    }
                }
            ];
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_RCC_ACTION
                }
            ];
    }
};
